import { getCdn } from "utils";
import Image from "./Image";
const componentName = "branding-character";

const BrandingCharacter = ({ url = `${getCdn()}/images/header/fairy.png` }) => (
	<div className={`syndicated-${componentName}`}>
		<Image
			name={componentName}
			image={{
				url,
				title: componentName,
			}}
		/>
	</div>
);

export default BrandingCharacter;
